"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrowseClassSubDialogModule = /** @class */ (function () {
    function BrowseClassSubDialogModule() {
    }
    return BrowseClassSubDialogModule;
}());
exports.BrowseClassSubDialogModule = BrowseClassSubDialogModule;
